import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { ClusterService } from '../../../Model/Cluster/cluster.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-cluster-form',
  standalone: true,
  imports: [FormsModule, CommonModule, NgSelectModule,LoaderComponent],
  templateUrl: './cluster-form.component.html',
  styleUrl: './cluster-form.component.scss'
})
export class ClusterFormComponent {
 isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);
  @Input() id!: number;
  @Input() Code!: string;
  @Input() Name!: string;
  @Input() BranchId!: any;
  BranchMaster : any[] = []
  // filter = {
  //   SelectType: 'S',
  //   ESS_ClusterMasterId: 0
  // }

  Detail = {
    SelectType: 'I',
    ESS_ClusterMasterId: 0,
    ClusterName: null as any,
    BranchID: null,
    UserId : 0,
    Code : null as any
  }
  constructor(
    private modalService: NgbModal,
    private toast: ToastService,
    private combo: ComboService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private cluster: ClusterService,
  ) {
    this.common.getPageRights();
    // this.common.PageRight.IsView = true;
    // this.common.PageRight.IsAdd = true;
    // this.common.PageRight.IsDelete = true;
    // this.common.PageRight.IsEdit = true;
    // this.common.PageRight.IsPrint = true;

    this.Detail.ESS_ClusterMasterId = this.id
  }

  ngOnInit(): void {
    this.ComboLoad('Branch');
    if (this.id > 0) {
      this.Detail.SelectType = 'U'
      this.Detail.ESS_ClusterMasterId  = this.id;
      this.Detail.Code = this.Code;
      this.Detail.ClusterName = this.Name;
      this.Detail.BranchID = this.BranchId
    }
    console.log(this.Detail)
  }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.isDisabled = true
    this.combo.ComboLoad({
      'Combotype': Combotype,
      // 'EmpType': 'front'
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.BranchMaster = response.ComboLoad;
        }
        this.isDisabled = false
      },
      complete: () => {
        this.isDisabled = false
      },
      error: (error) => {
      },
    });
  }

   async Save() {
    await this.common.getPageRights();
    console.log(this.Detail);
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Do you want save?'
    modalRef.result.then((result: any) => {
     if ((this.id == 0 && this.common.PageRight.IsAdd) || (this.id > 0 && this.common.PageRight.IsEdit)) {
      if (result) {
        this.isDisabled = true;
        this.Detail.ESS_ClusterMasterId = this.id
        this.cluster.ClusterMasterInsert(this.Detail).subscribe({
          next: (response) => {
            if (response.Error_Code == '596' || response.Error_Code == '597') {
              this.activeModal.close(true);
              this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
            }
            else {
              this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {
      // Modal dismissed
    });
  }

  close() {
    this.activeModal.close();
  }

}
